module.exports = __webpack_public_path__ + "images/txffc.c098.png";